import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "./app";
import api from "./api";
import API_URL from "../config/ApiUrl";

const AsteriskNumberByShadowPrefixReportSlice = createSlice({
  name: "AsteriskNumberByShadowPrefixReportSlice",
  initialState: {},
  reducers: {},
});
export const addAsteriskNumberByShadowPrefixReport =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const { prefix = "" } = payload || {};

      // Ensure `prefix` is included in the payload
      const requestBody: any = {
        prefix,
      };

      // Make the API request with the constructed body
      const res = await api.post(
        API_URL.ASTERISK_NUMBER_BY_SHADOW_PREFIX_REPORTS.ADD,
        requestBody
      );
      return Promise.resolve(res.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const fetchListAsteriskNumberByShadowPrefixReports =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      // Destructure payload with default values
      const {
        date = "",
        current = 1,
        page_size = 10,
        prefix = "",
      } = payload || {};

      // Construct the query string dynamically
      const actionParts = [
        `report_date=${date}`,
        `current=${current}`,
        `page_size=${page_size}`,
        `prefix=${prefix}`,
      ];

      // Join query parts
      const action = `?${actionParts.join("&")}`;

      // Make the API call
      const response = await api.get(
        API_URL.ASTERISK_NUMBER_BY_SHADOW_PREFIX_REPORTS.LIST + action
      );

      // Return the response data
      return Promise.resolve(response?.data?.data);
    } catch (error: any) {
      // Improved error handling
      return Promise.reject(error?.response?.data || error.message);
    }
  };

export const deleteAsteriskNumberByShadowPrefixReports =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(
        API_URL.ASTERISK_NUMBER_BY_SHADOW_PREFIX_REPORTS.DELETE,
        payload
      );
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export default AsteriskNumberByShadowPrefixReportSlice.reducer;
